interface SelfAssessmentStepIndicatorProps {
	currentStepIndex: number;
	totalSteps: number;
}

export default function SelfAssessmentStepIndicator({
	currentStepIndex,
	totalSteps,
}: SelfAssessmentStepIndicatorProps) {
	return (
		<div className="flex w-full gap-1">
			{Array.from({ length: totalSteps }, (_, i) => (
				<div
					key={i}
					className={`w-full h-1 min-w-[1px] rounded-full transition-all duration-300 ${
						i < currentStepIndex + 1 ? "bg-primary-blue" : "bg-primary-gray-lightest"
					}`}
				/>
			))}
		</div>
	);
}
